var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.GiftList",
    "options": {
        "objc_class_prefix": "MallGiftList",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "scene",
                    "id": 1
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "repeated",
                    "type": "GiftInfo",
                    "name": "gifts",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "AmountConfig",
                    "name": "amountConfigs",
                    "id": 2
                }
            ]
        },
        {
            "name": "GiftInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "giftId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "name",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "intro",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "price",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "experience",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canCombo",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "version",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "onLined",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "language",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "needLoad",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "showType",
                    "id": 14
                },
                {
                    "rule": "repeated",
                    "type": "GiftResourceInfo",
                    "name": "resources",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "vipGrade",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "playTimes",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "produceType",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "canSendToAllUsers",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "timeLimit",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "hostBill",
                    "id": 21
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "guardLevel",
                    "id": 22
                }
            ]
        },
        {
            "name": "GiftResourceInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "url",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "md5",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "json",
                    "id": 4
                }
            ]
        },
        {
            "name": "AmountConfig",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "amount",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "description",
                    "id": 2
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/living/gift/giftlist.pb.js